import React from 'react'
import { useGlobalContext } from '../Context';
import S from '../../pages/ListDam.module.css'
const moment=require('moment-jalaali')

const CattleHistoryCompare = ({data,data2}) => {
      const {Gender,Birthdate,EarTagNumber,BodyNumber,IsDeleted,Pen:{Name},SensorId,CattleStatusId}=JSON.parse(data)
    const {Gender:gender,Birthdate:birthdate,EarTagNumber:eartag,BodyNumber:bodynum,IsDeleted:isdelete,Pen:{Name:name},SensorId:sensorid,CattleStatusId:status}=JSON.parse(data2)
    const pbirth=moment(Birthdate).format('jYYYY-jMM-jDD')
    const pbirth2=moment(birthdate).format('jYYYY-jMM-jDD')
    
                    

    const {isOpenModal,closeModalls,openModalls}=useGlobalContext();

  return (
    <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <div className="editModalDamCon2 Ani AllFFFF">
        <div className={S.AnimContentLI} data-aos='fade'>
      <table>
        
        <tr>
    <th >مشخصات</th>
    <th>مقدار قدیم</th>
    <th>مقدار جدید</th>
  </tr>
  <tr>
    <td>جنسیت </td>
    <td>{Gender}</td>
    <td>{gender}</td>
  </tr>
  <tr>
    <td>تاریخ تولد</td>
    <td>{pbirth}</td>
    <td>{pbirth2}</td>
  </tr>
  <tr>
    <td>شماره گوش</td>
    <td>{EarTagNumber}</td>
    <td>{eartag}</td>
  </tr>
  <tr>
    <td>شماره بدن </td>
    <td>{BodyNumber}</td>
    <td>{bodynum}</td>
  </tr>
  <tr>
    <td> وضعیت </td>
    <td>{IsDeleted?'حذف شده':'فعال'}</td>
    <td>{isdelete?'حذف شده':'فعال'}</td>
  </tr>
  <tr>
    <td> بهاربند </td>
    <td>{Name}</td>
    <td>{name}</td>
  </tr>
  <tr>
    <td> سنسور </td>
    <td>{SensorId}</td>
    <td>{sensorid}</td>
  </tr>
  <tr>
    <td> وضعیت دام </td>
    <td>{CattleStatusId}</td>
    <td>{status}</td>
  </tr>
      </table>
    </div>
    </div>


    </div>
    
  )
}

export default CattleHistoryCompare
